import { SetupPermission } from './../../models/setup-permission';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { Int64Updater } from 'src/app/models/key-value';
import { Setup } from 'src/app/models/setup';
import { Urls } from 'src/app/models/urls';

@Injectable({
  providedIn: 'root'
})
export class SetupPermsService {

  url = new Urls();
  apiUrl: string;

  constructor(
    private httpclient: HttpClient
  ) {
      this.apiUrl = this.url.apiUrl;
  }

  getSetupPermissions(page, size, setupId) {
    // tslint:disable-next-line: max-line-length
    const url = this.apiUrl + '/api/setuppermission/' + page + '/' + size + '/' + setupId;
    return this.httpclient.get<any>(url)
    .pipe(
      tap( // Log the result or error
        error => this.handleError
      )
    );
  }

  postSetupPermissoin(perm: SetupPermission) {
    return this.httpclient.post(this.apiUrl + '/api/setuppermission', perm)
                    .pipe(
                      catchError(this.handleError)
                    );
  }

  deleteSetupPermission(perm: SetupPermission): Observable<any> {
    const val = JSON.stringify(perm);
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.httpclient.delete<any>(this.apiUrl + '/api/setuppermission/' + val, options)
                    .pipe(
                      catchError(this.handleError)
                    );
  }

  private handleError(error: any) {
    throw error;
    return error;
  }

}
